import Axios from 'axios'
import {
  expireSession,
  getFailure,
} from "@/common/base.js";
import ElementUI from "element-ui";
import {refreshToken} from "./base";
import {commonPRAS} from "./constant";

export {
  basementAjax,
  basementAjaxGet,
  basementAjaxDelete,
  basementAjax2,
  basementAjaxAsyncGet, basementAjaxGet2,
  postWithHeaders, fetchData
}
// 新增全局状态管理
let isRefreshing = false; // 刷新状态标志
let requests = []; // 待重试请求队列
const REFRESH_THROTTLE_TIME = 5000; // 5秒防抖时间
let lastRefreshTime = null; // 5秒防抖时间

// 请求拦截器
Axios.interceptors.request.use(
  config => {
    if (!config['url'].includes("techik/association/auth") && !config['url'].includes("techik/association/freeapi")) {
      config['headers']['Authorization'] = `Bearer ${localStorage.getItem(process.env.NODE_ENV+"_"+commonPRAS.tag+"_"+"accessToken")}`
    }
    config['headers']['client-type'] = commonPRAS.tag

    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('请求拦截器错误:', error)
    ElementUI.Message.error('请求发送失败')
    return Promise.reject(error)
  }
)
// 响应拦截器
Axios.interceptors.response.use(
  async response => {

    const res = response.data
    if (res instanceof ArrayBuffer) {
      return response;
    }
    const ur_l = response.config.url
    if (!res || !res.code ) {
      showMessage(ur_l,res.message)
      return response
    }
    const statusCode = Number.parseInt(res.code)
    // 根据后端返回的状态码判断请求是否成功
    if (statusCode && statusCode === 1) {
      return response;
    } else if (!response.config.url.includes("refreshToken")
      && !response.config.url.includes("login")
      && !response.config.url.includes("user/permission")
      && statusCode && statusCode == 101 || statusCode == 119 || statusCode == 120|| statusCode == 117) {
      console.log("accessToken过期，刷新令牌")
      // 1. 防止重复刷新
      if (!isRefreshing) {
        console.log("刷新")
        if (lastRefreshTime && Date.now() - lastRefreshTime < REFRESH_THROTTLE_TIME) {
          return Promise.reject(new Error("刷新令牌过于频繁"));
        }
        isRefreshing = true;
        return new Promise((resolve, reject) => {
          // 将当前请求加入队列（统一处理）
          requests.push({config: response.config, resolve, reject});

          refreshToken().then(() => {
            const newToken = localStorage.getItem(process.env.NODE_ENV+"_"+commonPRAS.tag+"_"+"accessToken");
            requests.forEach(({config, resolve, reject}) => {
              config.headers.Authorization = `Bearer ${newToken}`;
              Axios(config).then(resolve).catch(reject);
            });
            requests = [];
          }).catch(e => {
            // 刷新失败时拒绝所有请求
            requests.forEach(({reject}) => reject(e));
            requests = [];
            expireSession();
          }).finally(() => {
            isRefreshing = false;
          });
        });
      } else {
        console.log("不刷新")
        return new Promise((resolve, reject) => {
          requests.push({config: response.config, resolve, reject}); // 后续请求入队
        });
      }
    } else {
      const token = localStorage.getItem(process.env.NODE_ENV+"_"+commonPRAS.tag+"_"+"accessToken")
      if (token && token.length > 30 ) {
        showMessage(ur_l,res.message)
      }
      return response
    }
  },
  error => {
    // 对响应错误做点什么
    console.error('响应拦截器错误:', error)

    return error
  }
)

function basementAjax(that, url, param, success, failed, others, cdk) {
  Axios
    .post(url, param, {})
    .then(res => {
      const {code} = res.data
      if (code === 1) {
        success(res);
      } else if (code === 2) {
        //连接断开
        expireSession(that);
      } else if (code === 0) {
        //code为0其他行为
        others(res);
      } else if ([3, 4, 5].includes(code)) {
        //code为3其他行为
        cdk(res);
      } else {
        failed(res);
      }
    })
    .catch(error => {
      console.log(error)
      // getFailure(that);
    });
};

function basementAjax2(that, url, param, success, failed, headers) {
  Axios
    .post(url, param, {
      headers: headers
    })
    .then(res => {
      if (res.data.code == 1) {
        success(res);
      } else if (res.data.code == 2) {
        //连接断开
        expireSession(that);
      } else if (res.data.code == 0) {
        //code为0其他行为
        failed(res);
      } else {
        failed(res);
      }
    })
    .catch(error => {
      failed(error);
      console.log(error)
    });
};

//一般用于get请求（简单查看详情等无特殊操作的）
function basementAjaxGet(that, url, success, failed, others) {
  Axios
    .get(url, {})
    .then(res => {
      if (res.data.code == 1) {
        success(res);
      } else if (res.data.code == 2) {
        //连接断开
        expireSession(that);
      } else if (res.data.code == 0) {
        //code为0其他行为
        others(res);
      } else {
        failed(res);
      }
    })
    .catch(error => {
      console.log(error)
      // getFailure(that);
    });
};

function basementAjaxGet2(that, url, success, failed, others) {
  Axios
    .get(url, {})
    .then(res => {
      if (res.data.code == 1) {
        success(res);
      } else if (res.data.code == 2) {
        //连接断开
        expireSession(that);
      } else if (res.data.code == 0) {
        //code为0其他行为
        failed(res);
      } else {
        failed(res);
      }
    })
    .catch(error => {
      console.log(error)
      // getFailure(that);
    });
};

async function basementAjaxAsyncGet(that, url, success, failed, others) {
  await basementAjaxGet(that, url, success, failed, others)
};

//一般用于delete请求（删除等无特殊操作的）
function basementAjaxDelete(that, url, paramsF, success, failed) {
  Axios
    .delete(url, {
      params: paramsF
    })
    .then(res => {
      if (res.data.code == 1) {
        success(res);
      } else if (res.data.code == 2) {
        //连接断开
        expireSession(that);
      } else {
        failed(res);
      }
    })
    .catch(error => {
      getFailure(that);
    });
};
// 通用GET请求封装（支持同步/异步）
const fetchData = (url, config = {}) => {
  return new Promise((resolve) => {
    basementAjaxGet(
      null,
      url,
      res => resolve(res.data), // 成功回调
      err => {
        console.error(`[${url}] 请求失败:`, err);
        resolve([]) // 失败返回空数组保持数据格式
      },
      res => resolve([]) // code=0时的处理
    )
  })
}

// 特殊POST请求封装（如需要自定义header）
const postWithHeaders = (url, params, headers) => {
  return new Promise((resolve) => {
    basementAjax2(
      null,
      url,
      params,
      res => resolve(res.data),
      err => {
        console.error(`[${url}] 请求失败:`, err);
        resolve(null)
      },
      headers
    )
  })
}


function showMessage(url,message) {
  if (!url.includes("techik/association/freeapi/refresh") && !url.includes("techik/nameplatePics/original") && !url.includes("techik/asso/processRecord/download")) {
    ElementUI.Message({
      message: message || '请求失败',
      type: 'error',
      duration: 3000
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/ajax.js